(function () {
  'use strict';

  var GAP = 24;

  function getCardWidth() {
    var w = window.innerWidth;

    if (w <= 480) {
      return w - 16 - 136;
    } else if (w <= 768) {
      return (w - 48 - (GAP * 1.2)) / 2.2;
    } else if (w >= 1600) {
      return 310;
    } else {
      return (w - 50 - (GAP * 3.2)) / 4.1;
    }
  }

  function setCardWidths(section) {
    var width = Math.max(getCardWidth(), 180);
    var cards = section.querySelectorAll('.lp-sbs__card');

    cards.forEach(function (card) {
      card.style.width = width + 'px';
    });
  }

  function initSwatches(section) {
    var cards = Array.from(section.querySelectorAll('[data-lp-sbs-card]'));

    cards.forEach(function (card) {
      var swatches = card.querySelectorAll('[data-lp-sbs-swatch]');
      var mainImg = card.querySelector('[data-lp-sbs-main-image]');
      var variantImgs = card.querySelectorAll('[data-lp-sbs-variant-image]');
      var variantInput = card.querySelector('[data-lp-sbs-variant-input]');

      swatches.forEach(function (swatch) {
        function swapImage(targetVariant) {
          swatches.forEach(function (s) {
            s.classList.remove('lp-sbs__card__swatch--active');
          });

          swatch.classList.add('lp-sbs__card__swatch--active');

          var found = null;

          variantImgs.forEach(function (img) {
            if (img.dataset.lpSbsVariantImage === targetVariant) {
              found = img;
            }
          });

          if (found && mainImg) {
            mainImg.classList.remove('lp-sbs__card__image--active');
            mainImg.classList.add('lp-sbs__card__image--hidden');

            variantImgs.forEach(function (img) {
              img.classList.remove('lp-sbs__card__image--active');
              img.classList.add('lp-sbs__card__image--hidden');
            });

            found.classList.remove('lp-sbs__card__image--hidden');
            found.classList.add('lp-sbs__card__image--active');
          } else if (mainImg) {
            variantImgs.forEach(function (img) {
              img.classList.remove('lp-sbs__card__image--active');
              img.classList.add('lp-sbs__card__image--hidden');
            });

            mainImg.classList.remove('lp-sbs__card__image--hidden');
            mainImg.classList.add('lp-sbs__card__image--active');
          }
        }

        swatch.addEventListener('mouseenter', function () {
          swapImage(swatch.dataset.swatchVariant);
        });

        swatch.addEventListener('click', function () {
          swapImage(swatch.dataset.swatchVariant);

          if (variantInput && swatch.dataset.swatchVariant) {
            variantInput.value = swatch.dataset.swatchVariant;
          }
        });
      });
    });
  }

  function initSBS(section) {
    var sectionId = section.dataset.sectionId;
    var carouselEl = section.querySelector('#lp-sbs-carousel-' + sectionId);
    var prevBtn = section.querySelector('#lp-sbs-prev-' + sectionId);
    var nextBtn = section.querySelector('#lp-sbs-next-' + sectionId);

    if (!carouselEl) return;

    var instanceKey = 'lpSbsFlickity_' + sectionId;
    var existing = window[instanceKey];

    if (existing) {
      existing.destroy();
      window[instanceKey] = null;
    }

    setCardWidths(section);

    var flkty = new Flickity(carouselEl, {
      cellAlign: 'left',
      contain: true,
      groupCells: true,
      draggable: true,
      freeScroll: false,
      wrapAround: false,
      prevNextButtons: false,
      pageDots: false,
      friction: 0.28,
      selectedAttraction: 0.025,
      resize: true
    });

    window[instanceKey] = flkty;

    function updateButtons() {
      if (!prevBtn || !nextBtn) return;

      var isFirst = flkty.selectedIndex === 0;
      var isLast = flkty.selectedIndex === flkty.slides.length - 1;

      prevBtn.disabled = isFirst;
      nextBtn.disabled = isLast;

      prevBtn.classList.toggle('is-disabled', isFirst);
      nextBtn.classList.toggle('is-disabled', isLast);
    }

    flkty.on('select', updateButtons);
    flkty.on('settle', updateButtons);
    flkty.on('resize', updateButtons);

    updateButtons();

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        if (!prevBtn.disabled) {
          flkty.previous(true);
        }
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        if (!nextBtn.disabled) {
          flkty.next(true);
        }
      });
    }

    var resizeTimer;

    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);

      resizeTimer = setTimeout(function () {
        setCardWidths(section);
        flkty.resize();
        updateButtons();
      }, 120);
    });

    initSwatches(section);
  }

  function waitForFlickity(section) {
    if (typeof window.Flickity !== 'undefined') {
      initSBS(section);
    } else {
      setTimeout(function () {
        waitForFlickity(section);
      }, 50);
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    document
      .querySelectorAll('[data-section-type="lp-shop-best-sellers"]')
      .forEach(waitForFlickity);
  });

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('[data-section-type="lp-shop-best-sellers"]');

    if (section) {
      var instanceKey = 'lpSbsFlickity_' + section.dataset.sectionId;
      var existing = window[instanceKey];

      if (existing) {
        existing.destroy();
        window[instanceKey] = null;
      }

      setCardWidths(section);
      waitForFlickity(section);
    }
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var section = e.target.querySelector('[data-section-type="lp-shop-best-sellers"]');

    if (section) {
      var instanceKey = 'lpSbsFlickity_' + section.dataset.sectionId;
      var flkty = window[instanceKey];

      if (flkty) {
        flkty.destroy();
        window[instanceKey] = null;
      }
    }
  });
})();